import cookie_ from 'js-cookie'
import { detectedEnv } from '#app/lib/env_config'
import { LogError } from '#app/lib/loggers'
import { treq } from '#app/lib/treq'
import { parseBooleanString } from '#app/lib/utils'
import { commands } from '#app/radio'
import type { OwnerSafeUser } from '#server/controllers/user/lib/authorized_user_data_pickers'
import { requestLogout } from '#user/lib/auth'
import { initI18n } from './i18n'
import { solveLang } from './solve_lang'

// the cookie is deleted on logout
export const loggedIn = parseBooleanString(cookie_.get('loggedIn'))

// /!\ Do not try to use serializeUser, as that would create an circular dependency
// For a serialized main user, see ./serialized_main_user.ts
export const mainUser: OwnerSafeUser = await getMainUser()

async function getMainUser () {
  if (loggedIn) {
    try {
      const user = await treq('user', 'get', 'default')
      // Strictly speaking, user should be typed as (OwnerSafeUser | DeletedUser), but the deleted user case is sorted out with this logout
      if (user.type === 'deleted') void requestLogout()
      // /!\ Do not try to use serializeUser, as that would create an circular dependency
      // For a serialized main user, see ./serialized_main_user.ts
      return user as OwnerSafeUser
    } catch (err) {
      // Known to happen with vite in dev mode when an error occurs
      // Typically with: "ReferenceError: can't access lexical declaration 'shortLang' before initialization"
      if (detectedEnv === 'dev') {
        commands.execute('show:error', err)
        console.error('error at main user initialization: reloading', err)
        setTimeout(() => location.reload(), 1000)
      } else {
        // Known cases of session errors:
        // - when the server secret is changed
        // - when the current session user was deleted but the cookies weren't removed
        //   (possibly because the deletion was done from another browser or even another device)
        console.error('resetSession', err)
        void requestLogout('/login')
      }
    }
  }
}

export const waitForI18n = initI18n(solveLang(mainUser?.language)).catch(LogError('i18n initialize error'))

export async function deleteMainUserAccount () {
  await treq('user', 'delete', 'default')
  void requestLogout()
}
